import { render, staticRenderFns } from "./_siteSoftwareField.vue?vue&type=template&id=0c71a080"
import script from "./_siteSoftwareField.vue?vue&type=script&lang=js"
export * from "./_siteSoftwareField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports